import { useNavigate } from "react-router-dom";
import moment from "moment";
import Button from "@mui/material/Button";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import { concatParams, CreateParamsJson } from "../../helper/pathHelper";
import { clearLiveState } from "../../helper/liveControls";
import { useLanguage } from "../../i18n/LanguageContext";

export default function StartButton({ path, setConfig, config }) {
  const json = CreateParamsJson();
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <Button
      onClick={() => {
        navigate({
          pathname: path,
          search: concatParams({
            ...clearLiveState(json),
            starttime: moment().toISOString(),
          }),
        });
        setConfig(config++);
      }}
      startIcon={<PlayCircleFilledWhiteIcon />}
      variant="outlined"
    >
      {t("timer.restart")}
    </Button>
  );
}
